// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[4].use[2]!../../styles/common.module.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline_wrapper__1uawa {
  --track-height: 4px;

  position: relative;

  display: flex;
  flex: none;
  align-items: center;

  height: var(--thumb-size);
}

.timeline_rangeInput__kZpkJ {
}

@media (forced-colors: active) {
    .timeline_rangeInput__kZpkJ {
      border: none; /* The border should show in the chapter indicators instead */
    }
  }
.timeline_animated__6roCp {
}

.timeline_indicators__t1NV5 {
  position: absolute;

  overflow: hidden;

  width: 100%;
  height: 4px;

  background: var(--sliderBackgroundColor);

  transition: transform 0.2s;
}

@media (prefers-reduced-motion) {
    .timeline_indicators__t1NV5 {
      transition: none;
    }
  }

@media (forced-colors: active) {
    .timeline_indicators__t1NV5 {
      border: 1px solid ButtonBorder;
    }
  }
.timeline_wrapper__1uawa:hover .timeline_indicatorsHover__BskoG {
  transform: scaleY(2);
}

.timeline_indicators__t1NV5 div {
  position: absolute;
  height: 100%;
  opacity: 0.2;
  background: white;
}

@media (prefers-contrast: more) {
    .timeline_indicators__t1NV5 div {
      opacity: 0.5;
    }
  }

@media (forced-colors: active) {
    .timeline_indicators__t1NV5 div {
      background: ButtonText;
    }
  }

.timeline_indicators__t1NV5 div:nth-child(2) {
  opacity: 0.6;
}

@media (prefers-contrast: more) {
    .timeline_indicators__t1NV5 div:nth-child(2) {
      opacity: 0.9;
    }
  }

.timeline_indicators__t1NV5 div:nth-child(3) {
  opacity: 1;
  background: var(--primaryColor);
}

@media (forced-colors: active) {
    .timeline_indicators__t1NV5 div:nth-child(3) {
      background: ButtonText;
    }
  }

.timeline_input__1gA\\+2 {
  cursor: pointer;
  position: relative;
  width: 100%;
  background: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/timeline/timeline.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;;EAEnB,kBAAkB;;EAElB,aAAa;EACb,UAAU;EACV,mBAAmB;;EAEnB,yBAAyB;AAC3B;;AAEA;AAQA;;AALE;IACE;MACE,YAAY,EAAE,6DAA6D;IAC7E;EACF;AAEF;AAEA;;AAEA;EACE,kBAAkB;;EAElB,gBAAgB;;EAEhB,WAAW;EACX,WAAW;;EAEX,wCAAwC;;EAExC,0BAA0B;AAa5B;;AAXE;IACE;MACE,gBAAgB;IAClB;EACF;;AAEA;IACE;MACE,8BAA8B;IAChC;EACF;AAEF;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,iBAAiB;AAanB;;AAXE;IACE;MACE,YAAY;IACd;EACF;;AAEA;IACE;MACE,sBAAsB;IACxB;EACF;;AAGF;EACE,YAAY;AAOd;;AALE;IACE;MACE,YAAY;IACd;EACF;;AAGF;EACE,UAAU;EACV,+BAA+B;AAOjC;;AALE;IACE;MACE,sBAAsB;IACxB;EACF;;AAGF;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".wrapper {\n  --track-height: 4px;\n\n  position: relative;\n\n  display: flex;\n  flex: none;\n  align-items: center;\n\n  height: var(--thumb-size);\n}\n\n.rangeInput {\n  composes: rangeInput from '../../styles/common.module.css';\n\n  @media (forced-colors: active) {\n    & {\n      border: none; /* The border should show in the chapter indicators instead */\n    }\n  }\n}\n.animated {\n  composes: animated from '../../styles/common.module.css';\n}\n\n.indicators {\n  position: absolute;\n\n  overflow: hidden;\n\n  width: 100%;\n  height: 4px;\n\n  background: var(--sliderBackgroundColor);\n\n  transition: transform 0.2s;\n\n  @media (prefers-reduced-motion) {\n    & {\n      transition: none;\n    }\n  }\n\n  @media (forced-colors: active) {\n    & {\n      border: 1px solid ButtonBorder;\n    }\n  }\n}\n.wrapper:hover .indicatorsHover {\n  transform: scaleY(2);\n}\n\n.indicators div {\n  position: absolute;\n  height: 100%;\n  opacity: 0.2;\n  background: white;\n\n  @media (prefers-contrast: more) {\n    & {\n      opacity: 0.5;\n    }\n  }\n\n  @media (forced-colors: active) {\n    & {\n      background: ButtonText;\n    }\n  }\n}\n\n.indicators div:nth-child(2) {\n  opacity: 0.6;\n\n  @media (prefers-contrast: more) {\n    & {\n      opacity: 0.9;\n    }\n  }\n}\n\n.indicators div:nth-child(3) {\n  opacity: 1;\n  background: var(--primaryColor);\n\n  @media (forced-colors: active) {\n    & {\n      background: ButtonText;\n    }\n  }\n}\n\n.input {\n  cursor: pointer;\n  position: relative;\n  width: 100%;\n  background: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `timeline_wrapper__1uawa`,
	"rangeInput": `timeline_rangeInput__kZpkJ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["rangeInput"]}`,
	"animated": `timeline_animated__6roCp ${___CSS_LOADER_ICSS_IMPORT_0___.locals["animated"]}`,
	"indicators": `timeline_indicators__t1NV5`,
	"indicatorsHover": `timeline_indicatorsHover__BskoG`,
	"input": `timeline_input__1gA+2`
};
module.exports = ___CSS_LOADER_EXPORT___;
